import ButtonAnexarArquivos, {
  ButtonAnexarArquivosProps,
} from "./ButtonAnexarArquivos";
import { useState } from "react";
import useUploadAnexos from "core/features/arquivo/useUploadAnexos";
import { TempArquivo } from "core/features/arquivo/typings/";
import { showErrorAxios } from "infra/helpers/alerta";
import ModalUploadProgress from "ui/components/ModalUploadProgress";

export interface ButtonAnexarArquivosTempProps
  extends Omit<ButtonAnexarArquivosProps, "onAnexar"> {
  onFinishUploading?: (arquivos: TempArquivo[]) => any;
  horizontalAlignment?: boolean;
  showLoadingModal?: boolean;
}

function ButtonAnexarArquivosTemp({
  onFinishUploading,
  showLoadingModal = true,
  ...rest
}: ButtonAnexarArquivosTempProps) {
  const [uploading, setUploading] = useState<Record<string, number>>({});
  const { mutate: uploadAnexo, isLoading } = useUploadAnexos();

  const onAnexar = async (files: File[]) => {
    uploadAnexo(
      {
        files,
        onUploadProgress: (nome, value) => {
          setUploading((state) => ({ ...state, [nome]: value }));
        },
      },
      {
        onError: (e) => showErrorAxios(e),
        onSettled: () => setUploading({}),
        onSuccess: (anexos) => {
          onFinishUploading?.(anexos);
        },
      }
    );
  };

  return (
    <>
      <ButtonAnexarArquivos
        onAnexar={onAnexar}
        isLoading={isLoading}
        {...rest}
      />

      {showLoadingModal ? (
        <ModalUploadProgress uploading={uploading} isIndeterminate={false} />
      ) : null}
    </>
  );
}

export default ButtonAnexarArquivosTemp;
